import reducer from "./reducer";
export { default as Notes } from "./components/index";
export { default as notesReducerName } from "./constants";
export default reducer;
